module.exports = __webpack_public_path__ + "static/media/classplusLogo.bc79661c.svg";